import React, { createContext, useContext, useState, ReactNode } from "react";

interface DynamicSidebar {
  option: any;
  menu: any;
}

interface DynamicSidebarContextType {
  sidebar: DynamicSidebar | undefined;
  addDynamicSidebar: (option?: any, menu?: any) => void;
  removeDynamicSidebar: () => void;
}

const DynamicSidebarContext = createContext<
  DynamicSidebarContextType | undefined
>(undefined);

export const useDynamicSidebar = (): DynamicSidebarContextType => {
  const context = useContext(DynamicSidebarContext);
  if (!context) {
    throw new Error(
      "useDynamicSidebar must be used within a DynamicSidebarProvider"
    );
  }
  return context;
};

interface DynamicSidebarProviderProps {
  children: ReactNode;
}

export const DynamicSidebarProvider: React.FC<DynamicSidebarProviderProps> = ({
  children,
}) => {
  const [sidebar, setDynamicSidebar] = useState<DynamicSidebar>();
  const addDynamicSidebar = (option: any, menu: any) => {
    if (typeof option !== "undefined") {
      setDynamicSidebar({ option: option, menu: menu });
    }
  };
  const removeDynamicSidebar = () => {
    setDynamicSidebar(undefined);
  };

  return (
    <DynamicSidebarContext.Provider
      value={{ addDynamicSidebar, removeDynamicSidebar, sidebar }}
    >
      {children}
    </DynamicSidebarContext.Provider>
  );
};
